import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import React from "react";
import { CompanyProfile } from "./models";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

interface Props {
  value: CompanyProfile;
  onChange: (value: CompanyProfile) => void;
}

export const ProfilePicker = (props: Props) => {
  const { value, onChange } = props;
  return <div className="flex-column gap-large main-section-template-fields-padding">
    <div>
      <RadioGroup<server.dto.IsArtistTypes>
        orientation="vertical"
        options={[
          { label: "Artist", value: "active" },
          { label: "Artist, but no longer active", value: "noLongerActive" },
          { label: "Not an artist", value: "no" },
        ]}
        value={value.isArtist}
        onChange={v => onChange({ ...value, isArtist: v })}
      />
    </div>

    <div className="flex-column gap">
      <div>
        <Checkbox
          label={site.currentEnvironment.functionGroups.promoter.singular}
          checked={value.isPromoter === "active"}
          onChange={(_, checked) => onChange({ ...value, isPromoter: checked ? "active" : "no" })}
        />
      </div>
      <div>
        <Checkbox
          label={site.currentEnvironment.functionGroups.venue.singular}
          checked={value.isVenue === "active"}
          onChange={(_, checked) => onChange({ ...value, isVenue: checked ? "active" : "no" })}
        />
      </div>
    </div>
  </div>
}